export const constants = {
  CANCEL_INTERACTION: "Online Cancellation",
  SUBSCRIPTION_SAVED: "Subscription Saved"
} as const;
